import { type UseQueryResult, useQuery } from 'react-query';
import {
  StaticStatusDropdownService,
  type Wealthlane_CapTable_Dtos_Common_IntDropdownDto,
} from '@wealthlane/api-services/wealthlane-captable-service';
import { type OptionType } from '../../types/common';

const useGetParticipationTypes = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<OptionType[] | undefined, unknown> => {
  return useQuery(['getParticipationTypes'], async () => {
    const data = await handleRequest(
      StaticStatusDropdownService.getApiCapTableApiAppStaticStatusDropdownParticipationTypes()
    );
    return data?.map((item: Wealthlane_CapTable_Dtos_Common_IntDropdownDto) => ({
      label: item.name,
      value: item.id,
    }));
  });
};

export default useGetParticipationTypes;
